import React from "react";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
  Button,
  Typography,
  Slide,
} from "@mui/material";
import ErrorIcon from "@mui/icons-material/Error";

const InvitationStatusDialog = ({ open, onClose, inviteStatus }) => {
  const title =
    inviteStatus === "accepted"
      ? "Invite Accepted"
      : inviteStatus === "declined"
      ? "Invite Declined"
      : "Invalid or Expired Token";

  const description = inviteStatus
    ? "You have already responded to this invitation."
    : "Your invite link has expired or is invalid.";

  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          borderRadius: "12px",
          padding: "20px",
          width: { xs: "90%", sm: "400px" },
          height: "auto",
          maxWidth: "100%",
        },
      }}
      TransitionComponent={Slide}
      TransitionProps={{ direction: "up", timeout: 500 }}
    >
      <DialogContent
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          padding: 0,
        }}
      >
        <ErrorIcon sx={{ color: "#dc3545", fontSize: "50px" }} />
        <DialogTitle
          sx={{
            color: "#003D78",
            fontWeight: "bold",
            fontSize: "20px",
            padding: "12px 0",
          }}
        >
          {title}
        </DialogTitle>
        <Typography
          variant="body1"
          gutterBottom
          textAlign="center"
          sx={{ fontSize: "16px", marginTop: "8px", color: "#333", padding: "0 16px" }}
        >
          {description}
        </Typography>
      </DialogContent>
      <DialogActions
        sx={{ display: "flex", justifyContent: "center", padding: "16px 0" }}
      >
        <Button
          onClick={onClose}
          variant="contained"
          sx={{
            bgcolor: "#003D78",
            textTransform: "none",
            padding: "10px 24px",
            borderRadius: "8px",
            "&:hover": { bgcolor: "#002F60" },
          }}
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default InvitationStatusDialog;
